import { PlusIcon } from "../../../assets/imgs";
import Modal from "../../../components/Modal/Modal";
import { Field, Form, Formik } from "formik";
import FilledButton from "../../../components/FilledButton/FilledButton";
import * as Yup from "yup";
import { useStore } from "../../../store/useStore";
import GenericCompanyImage from "../../../components/GenericCompanyImage/GenericCompanyImage";
import { ReportType } from "../../../store/types/report";
import CustomDatePicker from "../../../components/FormComponents/CustomDatePicker/CustomDatePicker";

const initialValues = {
  periodStart: "",
  periodEnd: ""
};

const CreateAFDAEJReportModal: React.FC<{}> = () => {
  const downloadReport = useStore((state) => state.report.downloadReport);
  const reportType = useStore((state) => state.report.reportType);
  const isDownloadingReport = useStore(
    (state) => state.report.isDownloadingReport
  );
  const company = useStore((state) => state.navbar.company);

  return (
    <Modal
      title={reportType === ReportType.AEJ ? 'Relatório AEJ' : 'Relatório AFD'}
      icon={<PlusIcon width={30} height={30} />}
      className="w-[400px]"
      childrenClassName="px-5 overflow-y-auto"
    >
      <Formik
        initialValues={initialValues}
        validationSchema={Yup.object().shape({
          periodStart: Yup.string().required("Campo obrigatório"),
          periodEnd: Yup.string().required("Campo obrigatório"),
        })}
        onSubmit={(values) => {
          const data = {
            periodStart: values.periodStart,
            periodEnd: values.periodEnd
          };

          downloadReport(data);
        }}
        
      >
        {() => (
          <Form>
            <div className="flex flex-col items-center gap-8 pt-5">
                <div className="flex gap-5">
                  <div className="flex-1">
                    <Field
                      placeholder="Início da competência"
                      name="periodStart"
                      component={CustomDatePicker}
                      className="w-full"
                    />
                  </div>
                  <div className="flex-1">
                    <Field
                      placeholder="Fim da competência"
                      name="periodEnd"
                      endDate={true}
                      component={CustomDatePicker}
                      className="w-full"
                    />
                  </div>
                </div>
                <div className="flex gap-5">
                  <GenericCompanyImage
                    logo={company?.logo}
                    width={"40px"}
                    height={"40px"}
                    className="min-w-[40px] shadow-lg"
                  />
                  <span className="text-md">
                    {company?.name ?? "-"}
                  </span>
                </div>
                <div className="flex gap-5 justify-end my-6">
                    <FilledButton
                      loading={isDownloadingReport}
                      className="w-full h-[40px] min-w-[200px]"
                      type="submit"
                    >
                      Baixar relatório
                    </FilledButton>
                </div>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default CreateAFDAEJReportModal;
